import { getIsLocalhost } from "../utils/localhost.utils";

const useIsLocalhost = () => {
  return { isLocalhost: getIsLocalhost() };
};

export default useIsLocalhost;
